import { render } from "./EstilizacaoGlobal.vue?vue&type=template&id=15b8ef73"
import script from "./EstilizacaoGlobal.vue?vue&type=script&lang=js"
export * from "./EstilizacaoGlobal.vue?vue&type=script&lang=js"

import "./EstilizacaoGlobal.vue?vue&type=style&index=0&id=15b8ef73&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__